/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('variant:changed', function(event) {
  // console.log('event',event);
  let container = event.target;
  let variant = event.detail.variant;
  let variantID = variant.id;
  let qtyInput = container.querySelector('.QuantitySelector__CurrentQuantity');
  let jsonData = JSON.parse(container.querySelector('[data-product-json]').innerHTML);
  let minQuantities = jsonData['min_quantities'] || false;

  if (minQuantities) {
    let minQuantity = minQuantities[variantID].min_quantity;

    // Set min quantity
    // console.log('minQuantity',minQuantity);
    qtyInput.value = minQuantity;
    qtyInput.dataset.min  = minQuantity;
    qtyInput.dispatchEvent(new Event('change'));
  }
});

let inputQty = document.querySelector('[name="quantity"]');
inputQty.addEventListener('change', function () {
  
  let minQty = parseInt(this.getAttribute("data-min"));
  let currentValue = parseInt(this.value);
  if (currentValue < minQty) {
    this.value = minQty;
  }
});

$(document).ready(function(){
  $(".tab_content").hide();

  if($( window ).width() > 767){
  	$(".tab_content:first").show();
  }
  /* if in tab mode */
  $("ul.tabs li").click(function() {

    $(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();

    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    //$(".tab_drawer_heading").removeClass("d_active");
    //$(this).addClass("d_active");
  });
  $('.tab_drawer_heading').click(function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
    }
    else {
      $this.parent().parent().find('.tab_content').removeClass('show');
      $this.parent().parent().find('.tab_content').slideUp(350);
      //$this.next().toggleClass('show');
      //$this.next().slideToggle(350);
      $this.next().show();
    }
  });

  $(".accordion_btn").click(function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.hasClass('show')) {
      $this.removeClass('show');
      $this.next().slideUp(350);
    }
    else {
      $this.addClass('show');
      $this.next().slideDown(350);
    }
    PageInits.collection('.ProductItem__Info--inner');
  });

  $(".tab_lists a:not(.disabled)").click(function(e) {
    e.preventDefault();

    var $this = $(this);
	var activeTab = $(this).data("id");
    $(".tab_lists a").removeClass('active');
    $this.addClass('active');
    $(".tab_contents .tab_inner").fadeOut(0);
    $(".tab_contents .tab_inner[data-id^='"+activeTab+"']").fadeIn(300);

    PageInits.collection('.ProductItem__Info--inner');

  });

  setTimeout(function(){ $('.yotpo-pictures-gallery-title').text('Follow us @animamundiherbals'); }, 2000);
});

PageInits = {
  collection: function(a){
    var top = 0;
    var main = $(a);
    var randomClass = ( 'eH' + Math.random() ).replace('.','');
    // console.log('A random class: ' + randomClass); // ?
    main.each( function() {

      var distanceFromTop = $(this).offset().top;
      // console.log('This is ' + distanceFromTop + ' from the top.');

      if ( distanceFromTop > top ) {
        $('.' + randomClass).removeClass(randomClass);
        top = distanceFromTop;
        // console.log('"top" is ' + top + 'px away');
      }

      $(this).addClass(randomClass);

      $(this).css('height','auto');

      var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
        return $(this).outerHeight();
      }).get()));

      $('.' + randomClass).css('height',newHeight);

    }).removeClass(randomClass);

  }
}

$( window ).scroll(function() {
  PageInits.collection('.section-blog .ArticleItem__Content .ArticleItem__Title');
});

$( document ).ready(function() {
  'use strict';
  PageInits.collection('.menu-product-details');
  PageInits.collection('.ProductItem__Info--inner');

  var slider = $('.Slideshow__Carousel').flickity();
  var slider_2 = $('.shop-kook-slider').flickity();


  $(document).on("click",".arrow-wrap button.flickity-prev-next-button-next",function() {
    slider.flickity('next', true );
  });

  $(document).on("click",".arrow-wrap button.flickity-prev-next-button-previous",function() {
    console.log("previous");
    slider.flickity('previous', true );
  });


  $(document).on("click",".btn-slide.prev-next-button-next",function() {
     console.log("previous", $(this));
    slider_2.flickity('next', true );
  });

  $(document).on("click",".btn-slide.prev-next-button-previous",function() {
    console.log("previous");
    slider_2.flickity('previous', true );
  });



});

$(window).resize(function(){
  PageInits.collection('.menu-product-details');
  PageInits.collection('.ProductItem__Info--inner');
});


